/** Recent-post search path. Matches forum.FilterPostsByQuery (all terms, case-insensitive). */

export const RECENT_POSTS_SEARCH_LABEL = 'Search recent posts';

export type ForumPostsQuery = {
  q?: string | null;
  sort?: string | null;
  subSlug?: string | null;
};

export function forumPostsPath(qOrParams?: string | null | ForumPostsQuery): string {
  const params: ForumPostsQuery =
    typeof qOrParams === 'object' && qOrParams !== null ? qOrParams : { q: qOrParams };
  const search = new URLSearchParams();
  const q = (params.q ?? '').trim();
  if (q) search.set('q', q);
  const sort = (params.sort ?? '').trim();
  if (sort) search.set('sort', sort);
  const subSlug = (params.subSlug ?? '').trim();
  if (subSlug) search.set('subSlug', subSlug);
  const qs = search.toString();
  return qs ? `/forum/posts?${qs}` : '/forum/posts';
}

export function recentPostsSearchHref(basePath: string, query: string | null | undefined): string {
  const q = (query ?? '').trim();
  if (!q) return basePath;
  const joiner = basePath.includes('?') ? '&' : '?';
  return `${basePath}${joiner}q=${encodeURIComponent(q)}`;
}

export function recentPostsEmptyCopy(query: string | null | undefined, idleEmpty: string): string {
  const q = (query ?? '').trim();
  if (!q) return idleEmpty;
  return `No recent posts match “${q}”.`;
}

export function postMatchesQuery(title: string, body: string, q: string | null | undefined): boolean {
  const query = (q ?? '').trim().toLowerCase();
  if (!query) return true;
  const hay = `${title}\n${body}`.toLowerCase();
  return query.split(/\s+/).every((part) => part.length > 0 && hay.includes(part));
}
